@if (
  {
    isSubmitting: isSubmitting(),
    isLoggingOut: isLoggingOut$ | async,
    cities: citiesListener?.data$ | async,
    citiesLoadingError: citiesListener?.errorLoading$,
    districts: districtsListener?.data$ | async,
    districtsLoadingError: districtsListener?.errorLoading$,
    activities: activitiesListener?.data$ | async,
    activitiesListenerLoadingError: activitiesListener?.errorLoading$
  };
  as STATE
) {
  <div class="onboarding">
    <form
      [formGroup]="onboardingForm"
      [ngxsForm]="statePropertyPath"
      (ngSubmit)="onSubmit()"
      class="form"
    >
      <section class="onboarding__section">
        <hgroup>
          <p>Coordonnées du siège de l'entreprise</p>
          <span>Coordonnées géographiques de l'entreprise</span>
        </hgroup>

        <article class="onboarding__section__split">
          <section class="form__group">
            <label for="email" class="form__label"
              >Adresse email <span class="form__label-required">*</span></label
            >
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-msg" color="primary"></mat-icon>
              </span>
              <input
                type="email"
                id="email"
                formControlName="email"
                class="form__input"
                placeholder="Ex. john.doe@entreprise.com"
              />
            </div>
            @if (
              getControlField('email')?.touched &&
              getControlField('email')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
            @if (
              getControlField('email')?.touched &&
              getControlField('email')?.errors?.email
            ) {
              <mat-error class="form__error-red">
                Veuillez saisir une adresse email valide
              </mat-error>
            }
          </section>

          <section class="form__group">
            <phone-field
              uniqueId="phoneNumber"
              label="Téléphone"
              formControlName="phoneNumber"
              [preferredCountries]="['CI']"
            >
              @if (
                getControlField('phoneNumber')?.touched &&
                getControlField('phoneNumber')?.errors?.required
              ) {
                <mat-error class="form__error-red">
                  Ce champ est requis
                </mat-error>
              }
              @if (
                getControlField('phoneNumber')?.getError('httpError');
                as httpError
              ) {
                <mat-error [innerHtml]="httpError" class="form__error-red">
                </mat-error>
              }
              @if (
                getControlField('phoneNumber')?.touched &&
                getControlField('phoneNumber')?.errors?.phoneMaxLength
              ) {
                <mat-error class="form__error-red">
                  Le numero de telephone ne doit pas depasser 15 chiffres
                </mat-error>
              }
            </phone-field>
          </section>

          <section class="form__group">
            <label for="city" class="form__label"
              >Ville <span class="form__label-required">*</span></label
            >
            @if (STATE.cities) {
              <div class="form__item form__item--with-prefix relative">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>
                <ng-select
                  [items]="$any(STATE.cities)"
                  multiple="false"
                  clearable="true"
                  bindLabel="label"
                  appendTo="body"
                  bindValue="value"
                  clearAllText="Effacer"
                  placeholder="Veuillez saisir la ville"
                  formControlName="city"
                  (change)="initDistrictsListener($event?.value)"
                >
                </ng-select>
              </div>
            } @else {
              <loading-or-error
                (retry)="initCitiesListener()"
                [error$]="STATE.citiesLoadingError"
                spinnerSize="sm"
              ></loading-or-error>
            }

            @if (
              getControlField('city')?.touched &&
              getControlField('city')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
          </section>

          <section class="form__group">
            <label for="district" class="form__label"
              >Commune <span class="form__label-required">*</span></label
            >

            @if (STATE.districts) {
              <div class="form__item form__item--with-prefix">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>

                <ng-select
                  [items]="$any(STATE.districts)"
                  bindLabel="label"
                  clearable="false"
                  appendTo="body"
                  bindValue="value"
                  clearAllText="Effacer"
                  placeholder="Veuillez Saisir la commune"
                  formControlName="district"
                >
                </ng-select>
              </div>
            } @else {
              <loading-or-error
                (retry)="initDistrictsListener('ABIDJAN')"
                [error$]="STATE.districtsLoadingError"
                spinnerSize="sm"
              ></loading-or-error>
            }

            @if (
              getControlField('district')?.touched &&
              getControlField('district')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
          </section>

          <section class="form__group">
            <label for="neighborhood" class="form__label"
              >Quartier <span class="form__label-required">*</span></label
            >
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
              </span>
              <input
                type="text"
                id="neighborhood"
                class="form__input"
                formControlName="neighborhood"
                placeholder="Veuillez saisir le quartier"
              />
            </div>
            @if (
              getControlField('neighborhood')?.touched &&
              getControlField('neighborhood')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
          </section>

          <section class="form__group">
            <label for="location" class="form__label"
              >Adresse <span class="form__label-required">*</span></label
            >
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
              </span>
              <input
                type="text"
                id="location"
                class="form__input"
                formControlName="location"
                placeholder="Saisir l'adresse"
              />
            </div>
            @if (
              getControlField('location')?.touched &&
              getControlField('location')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
          </section>
        </article>
      </section>
      <section class="onboarding__section">
        <hgroup>
          <p>Informations sur l'activité</p>
          <span
            >Activité exercée et immatriculation officielle de
            l'entreprise</span
          >
        </hgroup>
        <article class="onboarding__section__split">
          <section class="form__group">
            <label for="activity" class="form__label"
              >Activité (Principale)<span class="form__label-required"
                >*</span
              ></label
            >

            @if (STATE.activities) {
              <div class="form__item form__item--with-prefix">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>
                <ng-select
                  [items]="$any(STATE.activities)"
                  bindLabel="label"
                  clearable="false"
                  appendTo="body"
                  bindValue="value"
                  clearAllText="Effacer"
                  placeholder="Veuillez sélectionnez l'activité"
                  formControlName="activity"
                >
                </ng-select>
              </div>
            } @else {
              <loading-or-error
                (retry)="initActivitiesListener()"
                [error$]="STATE.activitiesListenerLoadingError"
                spinnerSize="sm"
              ></loading-or-error>
            }

            @if (
              getControlField('district')?.touched &&
              getControlField('district')?.errors?.required
            ) {
              <mat-error class="form__error-red">
                Ce champ est requis
              </mat-error>
            }
          </section>
          <section class="form__group">
            <label for="rccNumber" class="form__label"
              >Registre du Commerce et du Crédit Mobilier (RCCM)</label
            >
            <div class="form__item form__item--with-prefix">
              <span class="form__prefix">
                <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
              </span>
              <input
                type="text"
                id="rccNumber"
                formControlName="rccNumber"
                class="form__input"
                placeholder="Veuillez Saisir le rccm"
              />
            </div>
          </section>
        </article>
      </section>
      <section class="onboarding__section">
        <hgroup>
          <p>Localisation du siège</p>
          <span>Adresse et géolocalisation pour la conformité.</span>
        </hgroup>

        <article class="onboarding__section__split">
          <section class="onboarding__section__split-space">
            <p class="onboarding__section__title">
              Position GPS (
              <a role="button" (click)="openMapDialog()"
                >Cliquer ici pour utiliser la carte</a
              >)
            </p>

            <div class="form__group">
              <label for="locationLink" class="form__label"
                >Lien Google Map</label
              >
              <div class="form__item form__item--with-prefix">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>
                <input
                  type="text"
                  id="locationLink"
                  class="form__input"
                  formControlName="locationLink"
                  placeholder="Coller le lien map ou les coordonnées GPS"
                />
              </div>

              @if (isLocationLinkInvalidFormat()) {
                <mat-error class="form__error-red">
                  Format non reconnu. Veuillez coller un lien Google Maps valide
                  ou utiliser la carte.
                </mat-error>
              }

              @if (isLocationLinkGeocodingFailed()) {
                <mat-error class="form__error-red">
                  Impossible d’extraire les coordonnées depuis ce lien. Veuillez
                  utiliser la carte.
                </mat-error>
              }
            </div>

            <section class="form__row">
              <div class="form__group">
                <label for="longitude" class="form__label"
                  >Longitude <span class="form__label-required">*</span></label
                >
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="longitude"
                    formControlName="longitude"
                    class="form__input"
                    placeholder="Ex: 2.2945"
                  />
                </div>
                @if (longitudeCtrl?.touched) {
                  @if (longitudeCtrl?.hasError('required')) {
                    <mat-error class="form__error-red">
                      Ce champ est requis
                    </mat-error>
                  } @else if (longitudeCtrl?.hasError('invalidFormat')) {
                    <mat-error class="form__error-red">
                      Format invalide (ex: -4.0365)
                    </mat-error>
                  } @else if (longitudeCtrl?.hasError('outOfRange')) {
                    <mat-error class="form__error-red">
                      La longitude doit être comprise dans le territoire de la
                      Côte d'Ivoire (entre -9 et -2)
                    </mat-error>
                  }
                }
              </div>

              <div class="form__group">
                <label for="latitude" class="form__label"
                  >Latitude <span class="form__label-required">*</span></label
                >
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="latitude"
                    formControlName="latitude"
                    class="form__input"
                    placeholder="Ex: 48.8584"
                  />
                </div>
                @if (latitudeCtrl?.touched) {
                  @if (latitudeCtrl?.hasError('required')) {
                    <mat-error class="form__error-red">
                      Ce champ est requis
                    </mat-error>
                  } @else if (latitudeCtrl?.hasError('invalidFormat')) {
                    <mat-error class="form__error-red">
                      Format invalide (ex: 5.3412)
                    </mat-error>
                  } @else if (latitudeCtrl?.hasError('outOfRange')) {
                    <mat-error class="form__error-red">
                      La latitude doit être comprise dans le territoire de la
                      Côte d'Ivoire (entre 4 et 11)
                    </mat-error>
                  }
                }
              </div>
            </section>
          </section>

          <section class="onboarding__section__split-space">
            <p class="onboarding__section__title">Référence Cadastrale</p>
            <section class="form__row">
              <div class="form__group">
                <label for="section" class="form__label">Section</label>
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="section"
                    formControlName="section"
                    class="form__input"
                    placeholder="Ex: 15"
                  />
                </div>
              </div>

              <div class="form__group">
                <label for="parcel" class="form__label">Parcelle</label>
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="parcel"
                    formControlName="parcel"
                    class="form__input"
                    placeholder="Ex: 12"
                  />
                </div>
              </div>
            </section>

            <section class="form__row">
              <div class="form__group">
                <label for="lot" class="form__label">Lot</label>
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="lot"
                    formControlName="lot"
                    class="form__input"
                    placeholder="Ex: 103"
                  />
                </div>
              </div>

              <div class="form__group">
                <label for="ilot" class="form__label">Ilot</label>
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="ilot"
                    formControlName="ilot"
                    class="form__input"
                    placeholder="Ex: 376"
                  />
                </div>
              </div>
            </section>
          </section>
        </article>

        <div class="mt-4 mb-2">
          <p class="onboarding__section__title mb-2">Propriétaire du local</p>
          <section class="onboarding__section__split">
            <div class="form__group">
              <label for="siteOwnerName" class="form__label"
                >Nom et prénom(s) / Raison sociale</label
              >
              <div class="form__item form__item--with-prefix">
                <span class="form__prefix">
                  <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                </span>
                <input
                  type="text"
                  id="siteOwnerName"
                  formControlName="siteOwnerName"
                  class="form__input"
                  placeholder="Nom et prénom(s) ou raison sociale"
                />
              </div>
            </div>
            <section class="form__row onboarding__section__ncc">
              <div class="form__group">
                <label for="siteOwnerNif" class="form__label"
                  >NCC du propriétaire</label
                >
                <div class="form__item form__item--with-prefix">
                  <span class="form__prefix">
                    <mat-icon svgIcon="dgi-list-otp" color="primary"></mat-icon>
                  </span>
                  <input
                    type="text"
                    id="siteOwnerNif"
                    formControlName="siteOwnerNif"
                    class="form__input"
                    placeholder="NCC du propriétaire"
                  />
                </div>
              </div>
              <div class="form__group">
                <phone-field
                  uniqueId="siteOwnerPhoneNumber"
                  label="Téléphone"
                  formControlName="siteOwnerPhoneNumber"
                  [preferredCountries]="['CI']"
                >
                  @if (
                    getControlField('siteOwnerPhoneNumber')?.touched &&
                    getControlField('siteOwnerPhoneNumber')?.errors?.required
                  ) {
                    <mat-error class="form__error-red"
                      >Ce champ est requis</mat-error
                    >
                  }
                  @if (
                    getControlField('siteOwnerPhoneNumber')?.getError(
                      'httpError'
                    );
                    as httpError
                  ) {
                    <mat-error [innerHtml]="httpError" class="form__error-red">
                    </mat-error>
                  }
                </phone-field>
              </div>
            </section>
          </section>
        </div>
      </section>

      <mat-divider class="form__divider"></mat-divider>

      <section class="form__actions onboarding__actions">
        <button
          type="button"
          [disabled]="STATE.isLoggingOut"
          class="btn btn-rectangle-primary"
          (click)="onLogout()"
        >
          Se déconnecter
        </button>

        <button
          button
          type="submit"
          class="onboarding__actions--btn-submit"
          [disabled]="
            !!(
              STATE.isSubmitting ||
              onboardingForm.invalid ||
              STATE.isLoggingOut
            )
          "
          [loading]="STATE.isSubmitting"
          [fullWidth]="true"
        >
          Suivant
        </button>
      </section>
    </form>
  </div>
}
